import React from 'react';
import PropTypes from 'prop-types';
import useLanguage from '../../../../hooks/useLanguage';
import { ThemeContext } from '../../../../context/ThemeProvider';
import { useLocomotiveScroll } from 'react-locomotive-scroll';

import PackagesModal from '../../../UiComponents/PackagesModal/PackagesModal';
import Arrow from '../../../../svg/arr_right_top.svg';
import Star from '../../../../svg/star_non_shadow.svg';

const ServicesPackages = ({ packagesData, promoData, autoScrollToFirstPack }) => {
  const langToggle = useLanguage;
  const { scroll, isReady } = useLocomotiveScroll();
  const { themeMode } = React.useContext(ThemeContext);
  const firstPackRef = React.useRef(null);
  const hasScrolledToFirstPack = React.useRef(false);
  const itemDefault = packagesData.Packages[0];
  const priceDefault =
    themeMode === 'Грн'
      ? itemDefault.price_uah
      : themeMode === 'Руб'
      ? itemDefault.price_rub
      : themeMode === 'Usd'
      ? itemDefault.price_usd
      : itemDefault.price_eur;

  const lessonPriceDefault = priceDefault / itemDefault.number_lessons;

  const [open, setOpen] = React.useState(null);
  const [selectedItem, setSelectedItem] = React.useState(0);

  function openModalHandler(e, index) {
    e.preventDefault();
    setOpen(!open);
    setSelectedItem(index);
    scroll.stop();
  }

  function closeModalHandler() {
    setOpen(false);
    scroll.start();
  }

  React.useEffect(() => {
    if (
      !autoScrollToFirstPack ||
      !isReady ||
      !scroll ||
      !firstPackRef.current ||
      hasScrolledToFirstPack.current
    ) {
      return;
    }
    hasScrolledToFirstPack.current = true;

    const scrollToFirstPack = () => {
      if (!firstPackRef.current) return;
      // The site header is `position: fixed` and stays on top of the page
      // content, so scrolling the pack flush to the very top would hide it
      // underneath the header — offset by the header's current height so
      // the pack lands fully visible below it.
      const header = document.querySelector('header');
      const headerHeight = header ? header.getBoundingClientRect().height : 0;
      scroll.update();
      scroll.scrollTo(firstPackRef.current, {
        duration: 800,
        offset: -(headerHeight + 20),
      });
    };

    if (document.readyState === 'complete') {
      scrollToFirstPack();
    } else {
      window.addEventListener('load', scrollToFirstPack, { once: true });
      return () => window.removeEventListener('load', scrollToFirstPack);
    }
  }, [autoScrollToFirstPack, isReady, scroll]);

  const selected = packagesData.Packages[selectedItem];

  return (
    <>
      <section id="second-section" className="packages" data-scroll-section>
        <div className="content-wrapper">
          <div className="packages-wrapper">
            {packagesData.Packages.map((item, index) => {
              const price =
                themeMode === 'Грн'
                  ? item.price_uah
                  : themeMode === 'Руб'
                  ? item.price_rub
                  : themeMode === 'Usd'
                  ? item.price_usd
                  : item.price_eur;

              const lessonPrice = price / item.number_lessons;
              const savingAll =
                item.number_lessons * lessonPriceDefault - price;
              const saving = index === 0 ? 0 : savingAll;

              return (
                <div
                  className="packages-item"
                  key={index}
                  ref={index === 0 ? firstPackRef : null}
                >
                  <div className="packages-item__header">
                    <p className="item__header-duration">
                      {langToggle(item.duration_ua, item.duration_ru)}
                    </p>
                    <span className="item__header-rate">
                      {langToggle(item.rate_ua, item.rate_ru)}
                    </span>
                  </div>

                  <div className="packages-item__content">
                    <div className="packages-item__price-wrapper">
                      <span className="packages-item__price">{price}</span>
                      <span className="packages-item__price-title">
                        {' / ' + themeMode}
                      </span>
                    </div>
                    <div className="lesson__count">
                      <span className="packages__item-title">
                        {langToggle('Кількість занять:', 'Количество занятий:')}
                      </span>
                      <span className="packages__item-count">
                        {item.number_lessons}
                      </span>
                    </div>
                    <div className="lesson__price">
                      <span className="packages__item-title">
                        {langToggle('Одне заняття:', 'Одно занятие:')}
                      </span>
                      <span className="packages__item-count">
                        {Math.trunc(lessonPrice)} <span> {themeMode}</span>
                      </span>
                    </div>
                    <div className="lesson__saving">
                      {/* <span className="packages__item-title">
                        {langToggle('Економія:', 'Экономия:')}
                      </span> */}
                      <span className="packages__item-title">
                        {langToggle('Пауза:', 'Пауза:')}
                      </span>
                      {/* <span className="packages__item-count">
                        {Math.trunc(saving)} <span> {themeMode}</span>
                      </span> */}
                      <span className="packages__item-count">
                        {index === 0 ? '0' : index === 1 ? '7' : '14'}
                        <span> {langToggle('днів', 'дней')}</span>
                      </span>
                    </div>
                    <div className="packages-item__button-wrapper">
                      <button
                        className="packages-item__button"
                        onClick={(e) => openModalHandler(e, index)}
                      >
                        <span className="packages-item__button-title__wrapper">
                          <span className="packages-item__button-title">
                            {langToggle('Замовити пакет', 'Заказать пакет')}
                          </span>
                        </span>

                        <span className="packages-item__button-icon">
                          <Star className="packages-item__button-icon__star" />
                          <Arrow className="packages-item__button-icon__arrow" />
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <PackagesModal
        packagesData={packagesData}
        promoCode={promoData}
        selected={selected}
        closeModalHandler={closeModalHandler}
        open={open}
      />
    </>
  );
};

ServicesPackages.propTypes = {
  packagesData: PropTypes.object,
  promoData: PropTypes.array,
  autoScrollToFirstPack: PropTypes.bool,
};

ServicesPackages.defaultProps = {
  autoScrollToFirstPack: false,
};

export default ServicesPackages;
